export const size = {
  mobile: "600px",
  tablet: "769px",
  laptopS: "1216px",
  laptop: "1360px",
};
